<template>
  <new-layout
   :backgroundImage="backgroundImage"
   :showLogo="true"
   :backgroundImage2x="backgroundImage2x"
  >
    <not-found-card class="access-denied-card shadow"/>
  </new-layout>
</template>

<script>
import NewLayout from '../feature/login/components/NewLayout.vue';
import NotFoundCard from '../components/ui/NotFoundCard.vue';

export default {
  name: 'not-found',
  metaInfo: {
    title: 'Página não encontrada',
  },
  data() {
    return {
      backgroundImage: 'https://cdn.parcelex.com.br/assets/v3/persons/parcelex-guy-404.png',
      backgroundImage2x: 'https://s3.amazonaws.com/cdn.parcelex.com.br/assets/v3/persons/parcelex-guy-404%402x.png',
    };
  },
  components: {
    NewLayout,
    NotFoundCard,
  },
  methods: {
    redirectToHome() {
      this.$router.push('/');
    },
  },
};
</script>
<style lang="scss" scoped >
</style>
